/** 클립보드 복사 (구형 브라우저 폴백 포함) */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* 폴백 시도 */
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export function canNativeShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'failed';

/** Web Share API → 실패 시 클립보드 복사로 폴백 */
export async function shareOrCopy(data: { title: string; text: string; url?: string }): Promise<ShareOutcome> {
  if (canNativeShare()) {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') return 'cancelled';
    }
  }
  const payload = data.url ? `${data.text}\n${data.url}` : data.text;
  return (await copyText(payload)) ? 'copied' : 'failed';
}
